import { Link } from "react-router-dom";
import { isNativeIOS } from "../lib/platform";

/**
 * SiteFooter — the single source of truth for the LLC-branded footer
 * that anchors every page on bilateralcalm.com. Rendered at the very
 * bottom of each top-level page component. Hidden inside the
 * Capacitor iOS shell so the app stays clean and clutter-free.
 *
 * Why this exists: Apple's App Store ownership-transfer paperwork
 * requires the operating LLC name + contact to be publicly discoverable
 * on every marketing surface of the domain. Rather than duplicating
 * the copy across 20+ pages we mount this component once per page.
 *
 * Existing marketing pages (HomePage, PricingPage, PracticesPage,
 * PracticeDetailPage, LandingPage) already have richer bespoke footers
 * with logo + nav; this component does NOT replace those. It is only
 * added to pages that currently have no footer.
 */
export const SiteFooter = () => {
  if (isNativeIOS()) return null;
  const year = new Date().getFullYear();
  return (
    <footer
      className="mt-16 border-t border-slate-200 bg-[#FBF8F1]"
      data-testid="site-footer"
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-sm text-[#4A5568]">
        <p className="leading-relaxed" data-testid="site-footer-legal">
          © {year}{" "}
          <span className="font-medium text-[#1B2349]">Mood and Sleep Clinic LLC</span>{" "}
          · Bilateral Calm™ ·{" "}
          <a
            href="mailto:mscwellness@protonmail.com"
            className="text-[#3090A8] underline underline-offset-2 hover:text-[#1B2349]"
            data-testid="site-footer-contact"
          >
            mscwellness@protonmail.com
          </a>
        </p>
        <nav className="flex flex-wrap gap-x-5 gap-y-2 text-sm" aria-label="Legal">
          <Link to="/terms" className="hover:text-[#1B2349] transition-colors">
            Terms
          </Link>
          <Link to="/privacy" className="hover:text-[#1B2349] transition-colors">
            Privacy
          </Link>
          <Link to="/security" className="hover:text-[#1B2349] transition-colors">
            Security
          </Link>
        </nav>
      </div>
    </footer>
  );
};

export default SiteFooter;
